import { createContext } from "react";
import PropTypes from 'prop-types';


export const DictationConfigContext = createContext()

export default function DictationConfigProvider(props) {
    const { children, ...config } = props

    return (
        <DictationConfigContext.Provider value={config}>
            {children}
        </DictationConfigContext.Provider>
    )
}

DictationConfigProvider.propTypes = {
    children: PropTypes.node,
}